<template>
  <div>
    <el-dialog
      title="Нууц үг сэргээх"
      :visible.sync="this.$root.resetPasswordDialog"
      width="420px"
      :before-close="handleClose"
      center
    >
      <div class="reset-password-info text_center">
        <p class="reset-password-message">
          Нууц үгээ сэргээхийн тулд манай Facebook хуудас эсвэл утсаар холбогдож,
          админтайгаа холбогдон сэргээнэ үү.
        </p>
        <div class="reset-password-contacts">
          <a
            class="contact-link"
            href="https://www.facebook.com/profile.php?id=100071635914582"
            target="_blank"
            rel="noopener noreferrer"
          >
            Facebook хуудас
          </a>
          <a class="contact-link" href="tel:+97680056089">
            Утас: 7272-1280
          </a>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ResetPassword',
  methods: {
    handleClose () {
      this.$root.resetPasswordDialog = false
    }
  }
}
</script>

<style scoped>
.reset-password-info {
  padding: 8px 4px 16px;
}

.reset-password-message {
  margin: 0 0 16px;
  line-height: 1.6;
  color: #374151;
  font-size: 15px;
}

.reset-password-contacts {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
}

.contact-link {
  color: #2563eb;
  text-decoration: none;
  font-weight: 600;
}

.contact-link:hover {
  text-decoration: underline;
}
</style>
